export default state => ({
  ...state,
  expandedItems: [],
});
